import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';

import Loader from 'components/Loader';
import classes from './button.module.scss';
import { IButton } from './types';

const Button: React.FC<IButton> = ({
	className,
	text,
	onClick,
	type,
	styleType = 'primary',
	href,
	disabled,
	isLoading,
}) => {
	const handleClick = (
		e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
	) => {
		if (onClick && !isLoading) {
			onClick(e);
		}
	};

	return href ? (
		<Link
			className={cn(classes.button, className, {
				[classes[styleType]]: !!styleType,
			})}
			onClick={handleClick}
			to={href}
		>
			{text}
		</Link>
	) : (
		<button
			className={cn(classes.button, className, {
				[classes[styleType]]: !!styleType,
				[classes.button__loading]: isLoading,
			})}
			onClick={handleClick}
			type={type}
			disabled={disabled}
		>
			{isLoading ? (
				<Loader
					className={classes.loader}
					itemClassName={classes.loaderItem}
				/>
			) : (
				text
			)}
		</button>
	);
};

export default Button;
